// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IStripeApplyPromotionCodeResult,
}                               from '../interfaces';

const stripeApplyPromotionCode = async ({
    test,
    promotionCode,
    paymentIntentId,
    previewNegotiatedPrice,
    userEmail,
}: {
    test: boolean,
    promotionCode: string,
    paymentIntentId: string,
    previewNegotiatedPrice?: boolean,
    userEmail?: string,
}): Promise<IStripeApplyPromotionCodeResult | null> => {
    const functions = getFunctions();
    const applyPromotionCode = httpsCallable<
        {
            test: boolean,
            promotionCode: string,
            paymentIntentId: string,
            previewNegotiatedPrice?: boolean,
            userEmail?: string,
        },
        IStripeApplyPromotionCodeResult | null
    >(
        functions,
        'stripeApplyPromotionCode',
    );

    return applyPromotionCode({
        test,
        promotionCode,
        paymentIntentId,
        previewNegotiatedPrice,
        userEmail,
    }).then((result) => {
        const promotionResult = result.data as IStripeApplyPromotionCodeResult | null;
        return promotionResult;
    }).catch((err) => {
        throw err;
    });
};

export default stripeApplyPromotionCode;
